import React from 'react';
import type { ComponentProps } from 'react';
import styled from '@emotion/styled';
import { textAlign } from 'styled-system';

import { Flex } from 'common/components/Flex';

const UnstyledSectionContainer = styled(Flex)<any>`
  ${textAlign};
`;

const SectionContainer = (props: ComponentProps<typeof UnstyledSectionContainer>) => (
  <UnstyledSectionContainer
    flexDirection={['column', 'row']}
    alignItems={['flex-start', 'center']}
    textAlign="left"
    {...props}
  />
);

export default SectionContainer;
